import { Event } from "event-system";
import { IRenderer, Rectangle } from "@pixi/core";
import { ICanvasScaler } from "./ICanvasScaler";

export class CanvasScaler implements ICanvasScaler {
    public readonly onResize: Event<Scales>;

    private currentRatio: number;
    private currentScales: Scales;

    private widthBoundsDiffValue: number;

    public get browserWidth(): number {
        return window.innerWidth;
    }
    public get browserHeight(): number {
        return window.innerHeight;
    }

    public get referenceWidth(): number {
        return this.currentScales.width;
    }

    public get referenceHeight(): number {
        return this.currentScales.height;
    }

    public get referenceRatio(): number {
        return this.currentRatio;
    }

    public get widthBoundsDiff(): number {
        return this.widthBoundsDiffValue;
    }

    public constructor(
        private readonly renderer: IRenderer,
        private readonly targetScales: Array<Scales>
    ) {
        this.onResize = new Event<Scales>();
        window.onresize = this.resize.bind(this);
        this.resize();
    }

    public getSize(): Scales {
        return new Scales(this.currentScales.width, this.currentScales.height);
    }

    public resize(): void {
        const scales = new Scales(this.browserWidth, this.browserHeight);
        this.renderer.resize(scales.width, scales.height);
        this.currentScales = this.getTargetScale(scales);
        this.currentRatio = this.currentScales.width / this.currentScales.height;
        this.widthBoundsDiffValue = Math.max(Math.min((this.currentScales.width - this.browserWidth) * 0.5, 100), 0);
        this.onResize.emit(this.currentScales);
    }

    public get BASE_RESOLUTION(): { height: number, width: number } {
        return { height: this.referenceHeight, width: this.referenceWidth }
    }

    private getTargetScale(currentScales: Scales): Scales {
        const ratio = currentScales.width / currentScales.height;
        let bestScale: Scales = null;
        let minRatioDiff = Infinity;
        for (const targetScale of this.targetScales) {
            const targetRatio = targetScale.width / targetScale.height;
            const ratioDiff = Math.abs(ratio - targetRatio);
            if (ratioDiff <= minRatioDiff) {
                minRatioDiff = ratioDiff;
                bestScale = targetScale;
            }
        }
        console.log(`Target scale: ${bestScale.width}x${bestScale.height}`);
        return bestScale;
    }

    public get bounds(): Rectangle {
        return new Rectangle(0, 0, this.referenceWidth, this.referenceHeight);
    }
}

export class Scales {
    public readonly height: number;
    public readonly width: number;

    public constructor(width: number, height: number) {
        this.height = Math.floor(height);
        this.width = Math.floor(width);
    }
}